const  URLS = {
    WIDGET_BUTTON: 'widget/button',
    LOCATION: 'ip/location',
    TRANSLATION: 'label/button/translation',
    STATIC_TRANSLATION: 'label/button/static/translation',
    OPTIN: 'marketing/opt-in-messages',
    CALENDARS: 'widget/button/{%id}/calendars',
    CALENDAR: 'calendar',
    
    OAUTH_SESSION: 'oauth-session',
    SUBSCRIBER_ACTIVE: 'subscriber/active',
    POST_SUBSCRIBER: 'subscriber',
    COMPLETE_SUBSCRPITION: 'complete-subscription',

    SUBSCRIBER_STATUS: 'subscriber/{%id}/status/',
    DATA: 'data',
}

export default URLS;